import { setSessionData } from "../../Shared/helper/storage";
import { CONFIG_KEY, FTTX_VERSION_TEXT, GB, MAX_LENGTH_ERROR, P3_TEXT, USER_DEVICE_ID, USER_SESSION_ID ,MIN_LENGTH_ERROR} from "../GlobalConstant";
import { BROADBAND_RECHARGE_ROUTE, BROADBAND_ROUTE, CHECK_ORDER_STATUS_ROUTE, DATA_CALCULATOR, DEFAULT_ROUTE, PAYMENT_NEW_ROUTE, POSTPAID_ROUTE, PREPAID_ROUTE, BUY_BUNDLE_ROUTE, BROADBAND_RECHARGE_ROUTE_V3, BROADBAND_LINKED_DEVICES_ROUTE } from "../../app/routes/routeConstant";

export function createLabel(translation, args) {
  let i = 0;
  return translation.replace(/\$\{[^\}]+\}/g, function () {
    const label = args?.[i++] ?? "";
    return label;
  });
}

export const getCurrentDate = (dateFormat = 'en-GB') => {
  const date = new Date();
  const formatted = date.toLocaleDateString(dateFormat, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
  return formatted
}

export const getImgUrl = (imgName, path = "kenya/assets/fttx") => {
  return imgName ? `${process.env.REACT_APP_CDN_IMG_BASE_URL}/${path ? `${path}/` : ''}${imgName}` : imgName
}

export const getORPImgUrl = (imgName, path = "") => {
  return `${process.env.REACT_APP_CDN_IMG_BASE_URL}/kenya/assets/${path ? `${path}/` : ''}${imgName}`
}

export const getErrorMsg = (value, field, maxValue, minValue) => {

  let error = {}
  const { maxLength, regex, errorMessage = {} } = field;
  const inputLength = value?.length;
  const regexTest = new RegExp(regex);
  if (value === "") {
    return value;
  }

  if ((inputLength > maxLength)) {
    error = { maxLengthError: errorMessage?.[MAX_LENGTH_ERROR] ?? true }
  }
  
  if (+value < +minValue) {
    error = { minLengthError: errorMessage?.[MIN_LENGTH_ERROR] ?? true }
  }

  return error
}

export const normalizePath = (path) =>
  path !== "/" && path.endsWith("/")
    ? path.slice(0, -1)
    : path;

export const getProductCode = (pathName, searchParams = {}) => {
  const { AWCONFIG, PAYMENTCONFIG, CALCCONFIG, ORPCONFIG, GLOBAL_CONFIG, P3_AWCONFIG, FTTX_RECHARGE_CONFIG, HOMEPAGE_CONFIG } = CONFIG_KEY;
  let productCode = GLOBAL_CONFIG;
  switch (normalizePath(pathName)) {
    case PAYMENT_NEW_ROUTE:
      productCode = PAYMENTCONFIG;
      break;
    case BROADBAND_ROUTE:
    case "/plans/mifi":
    case "/plans/broadband":
    case CHECK_ORDER_STATUS_ROUTE:
      productCode = searchParams?.get?.(FTTX_VERSION_TEXT) === P3_TEXT ? P3_AWCONFIG : AWCONFIG;
      break;
    case DATA_CALCULATOR:
      productCode = CALCCONFIG;
      break;
    case PREPAID_ROUTE:
    case BROADBAND_RECHARGE_ROUTE:
      productCode = [ORPCONFIG, FTTX_RECHARGE_CONFIG];
      break;
    case BROADBAND_RECHARGE_ROUTE_V3:
    case BROADBAND_LINKED_DEVICES_ROUTE:
      productCode = FTTX_RECHARGE_CONFIG;
      break;
    case POSTPAID_ROUTE:
    case BUY_BUNDLE_ROUTE:
      productCode = ORPCONFIG;
      break;
    case DEFAULT_ROUTE:
      productCode = HOMEPAGE_CONFIG
      break;
    default:
      break;
  }
  return [].concat(productCode);
};

export const getSessionData = (sessionKey) => {
  const sessionData = sessionStorage.getItem(sessionKey);
  return sessionData ? JSON.parse(sessionData) : null;
}

export const getLocalStorageData = (Key) => {
  const sessionData = localStorage.getItem(Key);
  return sessionData ? JSON.parse(sessionData) : null;
}

export const setLocalStorageData = (Key, value) => {
  const sessionData = localStorage.setItem(Key, JSON.stringify(value));
  return sessionData ? JSON.parse(sessionData) : null;
}


export const memoizedFunction = (fn) => {
  const cache = new Map();

  return (value, key) => {
    if (cache.has(key)) {
      return cache.get(key);
    }
    const result = fn(value);
    cache.set(key, result);
    return result;
  };
}


export const isHTML = (str) => {
  return /<\/?[a-z][\s\S]*>/i.test(str);
}


export const loadScript = (src) =>
  new Promise((resolve, reject) => {
    const script = document.createElement("script");

    script.src = src;
    script.async = true;
    script.onload = resolve;
    script.onerror = reject;

    document.body.appendChild(script);
  });
export function createEventId() {
  if (window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }

  return `${Date.now()}-${Math.random().toString(36)}`;
}

export const getUserSessionId = () => {
  const userSessionId = getSessionData(USER_SESSION_ID);
  if (!userSessionId) {
    const eventId = createEventId();
    setSessionData(USER_SESSION_ID, eventId)
    return eventId
  }
  return userSessionId
}

export const getUserDeviceId = () => {
  const userDeviceId = getLocalStorageData(USER_DEVICE_ID);
  if (!userDeviceId) {
    const eventId = createEventId();
    setLocalStorageData(USER_DEVICE_ID, eventId)
    return eventId
  }
  return userDeviceId
}

export const formatDataSize = (value, unit, getText) => {
  if (value) {
    if (value < 1024) return `${value} ${unit}`;
    let formattedValue = (value / 1024).toFixed(2);
    return `${formattedValue} ${getText(GB)}`;
  }
}

export const isObject = (value) => value !== null && typeof value === "object";
